var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8784 1.49453C10.8214 -0.138805 13.1789 -0.138799 14.1219 1.49453L22.9121 16.7195C23.8551 18.3529 22.6763 20.3945 20.7903 20.3945H3.21C1.32399 20.3945 0.145236 18.3529 1.08824 16.7195L9.8784 1.49453ZM12.0001 5.00154C12.58 5.00154 13.0501 5.47164 13.0501 6.05154V10.9515C13.0501 11.5314 12.58 12.0015 12.0001 12.0015C11.4202 12.0015 10.9501 11.5314 10.9501 10.9515V6.05154C10.9501 5.47164 11.4202 5.00154 12.0001 5.00154ZM12.0001 17.6015C12.7733 17.6015 13.4001 16.9747 13.4001 16.2015C13.4001 15.4283 12.7733 14.8015 12.0001 14.8015C11.2269 14.8015 10.6001 15.4283 10.6001 16.2015C10.6001 16.9747 11.2269 17.6015 12.0001 17.6015Z",
    fill: "#BA4E41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRed);
export default __webpack_public_path__ + "static/media/errorRed.7d8d79e25dd277245356c971cab841b5.svg";
export { ForwardRef as ReactComponent };